import LandingPageBlurb from '@/app/components/LandingPage/LandingPageBlurb';
import LandingPageCards from '@/app/components/LandingPage/LandingPageCards';

const PartnershipsJourney = () => {
  return (
    <section
      data-cy="partnerships-journey"
      className="mt-20 flex flex-col gap-10 lg:gap-20"
    >
      <LandingPageBlurb
        description={{
          alignment: 'top',
          key: 'partnerships_journey_copy',
        }}
        title={{
          colEnd: { lg: 13, xxl: 11 },
          key: 'partnerships_journey_title',
          multiline: true,
        }}
      />
      <LandingPageCards
        cards={[
          {
            description: {
              messageKey: 'partnerships_cards_womens_health_copy',
            },
            id: 'womens_health',
            image: {
              localizedAlt: 'experience_style_image_1_alt',
              src: 'partnerships/or4/smiling-hand-face',
            },
            title: {
              messageKey: 'partnerships_cards_womens_health',
            },
          },
          {
            description: {
              messageKey: 'partnerships_fitness_copy',
            },
            id: 'fitness',
            image: {
              localizedAlt: 'partnership_fitness_alt',
              src: 'blue-sky/partnerships/fitness',
            },
            title: {
              messageKey: 'partnerships_fitness',
            },
          },
          {
            description: {
              messageKey: 'partnerships_behavioral_health_copy',
            },
            id: 'behavioral_health',
            image: {
              localizedAlt: 'partnerships_behavioral_health_alt',
              src: 'blue-sky/partnerships/behavioral-health',
            },
            title: {
              messageKey: 'partnerships_behavioral_health',
            },
          },
          {
            description: {
              messageKey: 'partnerships_metabolic_health_copy',
            },
            id: 'metabolic_health',
            image: {
              localizedAlt: 'partnerships_metabolic_health_alt',
              src: 'blue-sky/partnerships/metabolic-health',
            },
            title: {
              messageKey: 'partnerships_metabolic_health',
            },
          },
        ]}
      />
    </section>
  );
};

export default PartnershipsJourney;
